import { Checkbox, FormControlLabel, styled } from '@mui/material';
import { EditButton } from '@shared/Resources/Skill/Builder/styles';
import TextArea from '@components/TextArea';

const avatarSize = 40;

export const FeedbackPostContainer = styled('div')(
  {
    padding: 18,
    borderRadius: 4,
    marginBottom: 10,
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.novotalk.$backgroundColor,
  })
);

export const FeedbackPostHeader = styled('div')({
  display: 'grid',
  gridTemplateColumns: `${avatarSize + 10}px auto`,
  alignItems: 'center',
  marginBottom: 18,
});

export const PostAvatar = styled('img')({
  width: avatarSize,
  height: avatarSize,
  borderRadius: '50%',
  objectFit: 'cover',
});

export const PostDetails = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  '& span.postedOn': {
    whiteSpace: 'pre',
  },
});

export const PostText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  lineHeight: '23px',
  '& .postText': {
    minHeight: 180,
    padding: '7px 10px',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 4,
    whiteSpace: 'pre-wrap',
  },
}, ({ theme }) => ({
  '& .postText': {
    borderColor: theme.palette.novotalk.$inputBorderColor,
    backgroundColor: theme.palette.novotalk.$backgroundColor,
  },
}));

export const ActionButtonsWrapper = styled('div')({
  gridColumn: 3,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 6,
});

export const IconWrapper = styled(EditButton)`
  float: right;
`;

export const EmojiPickerWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginRight: 2,
});

export const StyledTextArea = styled(TextArea)({
  height: 180,
});

export const MeaningfulFeedbackControl = styled(FormControlLabel)(({ theme }) => ({
  margin: '8px 0 0',
  color: theme.palette.novotalk.$textColorDarkBlue,
  '& .MuiFormControlLabel-label': {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 500,
  },
}));

export const MeaningfulFeedbackCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: 6,
  color: theme.palette.novotalk.$selectStandartColor,
  '&.Mui-checked': {
    color: theme.palette.novotalk.$selectEnabledColor,
  },
  '&.Mui-disabled.Mui-checked': {
    color: theme.palette.novotalk.$selectStandartColor,
  },
}));
